import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const DocumentEditorCmp_VirtualRoot_Section_Fragment = graphql(`
  fragment DocumentEditorCmp_VirtualRoot_Section on Section {
    _id
    template {
      _id
      type
    }
    contentOriginId
    isVirtual
    hasPagebreakBefore
    hasPagebreakAfter
    title
    content
    orientation
    paperFormat
    isInsertionPoint
    customLayouts {
      _id
      sectionId
      orientation
      paperFormat
      hasPagebreakAfter
      hasPagebreakBefore
    }
    displayCondition {
      mode
      resolverId
      value
    }

    subSections {
      _id
      template {
        _id
        type
      }
      contentOriginId
      isVirtual
      hasPagebreakBefore
      hasPagebreakAfter
      title
      content
      orientation
      paperFormat
      isInsertionPoint
      customLayouts {
        _id
        sectionId
        orientation
        paperFormat
        hasPagebreakAfter
        hasPagebreakBefore
      }
      displayCondition {
        mode
        resolverId
        value
      }

      subSections {
        _id
        template {
          _id
          type
        }
        contentOriginId
        isVirtual
        hasPagebreakBefore
        hasPagebreakAfter
        title
        content
        orientation
        paperFormat
        isInsertionPoint
        customLayouts {
          _id
          sectionId
          orientation
          paperFormat
          hasPagebreakAfter
          hasPagebreakBefore
        }
        displayCondition {
          mode
          resolverId
          value
        }

        subSections {
          _id
          template {
            _id
            type
          }
          contentOriginId
          isVirtual
          hasPagebreakBefore
          hasPagebreakAfter
          title
          content
          orientation
          paperFormat
          isInsertionPoint
          customLayouts {
            _id
            sectionId
            orientation
            paperFormat
            hasPagebreakAfter
            hasPagebreakBefore
          }
          displayCondition {
            mode
            resolverId
            value
          }

          subSections {
            _id
            template {
              _id
              type
            }
            contentOriginId
            isVirtual
            hasPagebreakBefore
            hasPagebreakAfter
            title
            content
            orientation
            paperFormat
            isInsertionPoint
            customLayouts {
              _id
              sectionId
              orientation
              paperFormat
              hasPagebreakAfter
              hasPagebreakBefore
            }
            displayCondition {
              mode
              resolverId
              value
            }

            subSections {
              _id
              template {
                _id
                type
              }
              contentOriginId
              isVirtual
              hasPagebreakBefore
              hasPagebreakAfter
              title
              content
              orientation
              paperFormat
              isInsertionPoint
              customLayouts {
                _id
                sectionId
                orientation
                paperFormat
                hasPagebreakAfter
                hasPagebreakBefore
              }
              displayCondition {
                mode
                resolverId
                value
              }

              subSections {
                _id
                template {
                  _id
                  type
                }
                contentOriginId
                isVirtual
                hasPagebreakBefore
                hasPagebreakAfter
                title
                content
                orientation
                paperFormat
                isInsertionPoint
                customLayouts {
                  _id
                  sectionId
                  orientation
                  paperFormat
                  hasPagebreakAfter
                  hasPagebreakBefore
                }
                displayCondition {
                  mode
                  resolverId
                  value
                }

                subSections {
                  _id
                  template {
                    _id
                    type
                  }
                  contentOriginId
                  isVirtual
                  hasPagebreakBefore
                  hasPagebreakAfter
                  title
                  content
                  orientation
                  paperFormat
                  isInsertionPoint
                  customLayouts {
                    _id
                    sectionId
                    orientation
                    paperFormat
                    hasPagebreakAfter
                    hasPagebreakBefore
                  }
                  displayCondition {
                    mode
                    resolverId
                    value
                  }

                  subSections {
                    _id
                    template {
                      _id
                      type
                    }
                    contentOriginId
                    isVirtual
                    hasPagebreakBefore
                    hasPagebreakAfter
                    title
                    content
                    orientation
                    paperFormat
                    isInsertionPoint
                    customLayouts {
                      _id
                      sectionId
                      orientation
                      paperFormat
                      hasPagebreakAfter
                      hasPagebreakBefore
                    }
                    displayCondition {
                      mode
                      resolverId
                      value
                    }

                    subSections {
                      _id
                      template {
                        _id
                        type
                      }
                      contentOriginId
                      isVirtual
                      hasPagebreakBefore
                      hasPagebreakAfter
                      title
                      content
                      orientation
                      paperFormat
                      isInsertionPoint
                      customLayouts {
                        _id
                        sectionId
                        orientation
                        paperFormat
                        hasPagebreakAfter
                        hasPagebreakBefore
                      }
                      displayCondition {
                        mode
                        resolverId
                        value
                      }

                      subSections {
                        _id
                        template {
                          _id
                          type
                        }
                        contentOriginId
                        isVirtual
                        hasPagebreakBefore
                        hasPagebreakAfter
                        title
                        content
                        orientation
                        paperFormat
                        isInsertionPoint
                        customLayouts {
                          _id
                          sectionId
                          orientation
                          paperFormat
                          hasPagebreakAfter
                          hasPagebreakBefore
                        }
                        displayCondition {
                          mode
                          resolverId
                          value
                        }

                        subSections {
                          _id
                          template {
                            _id
                            type
                          }
                          contentOriginId
                          isVirtual
                          hasPagebreakBefore
                          hasPagebreakAfter
                          title
                          content
                          orientation
                          paperFormat
                          isInsertionPoint
                          customLayouts {
                            _id
                            sectionId
                            orientation
                            paperFormat
                            hasPagebreakAfter
                            hasPagebreakBefore
                          }
                          displayCondition {
                            mode
                            resolverId
                            value
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export const DocumentEditorCmp_OneTemplateDependency_QueryDocument = graphql(`
  query DocumentEditorCmp_OneTemplateDependency_Query(
    $id: Id!
    $type: TemplateTypeEnum!
  ) {
    findOneTemplate(id: $id, type: $type) {
      __typename
      ... on SectionTemplate {
        _id
        codingConfig {
          kind
          strategyId
          ... on CodingConfigManual {
            code
          }
        }
        code
        label
        typeId
        creatorId
        updaterId
        createdAt
        updatedAt
        statusId
        virtualRoot {
          ...DocumentEditorCmp_VirtualRoot_Section
        }
      }
      ... on DocumentTemplate {
        _id
        codingConfig {
          kind
          strategyId
          ... on CodingConfigManual {
            code
          }
        }
        code
        label
        creatorId
        updaterId
        createdAt
        updatedAt
        statusId
        document {
          _id
          codingConfig {
            kind
            strategyId
            ... on CodingConfigManual {
              code
            }
          }
          code
          typeId
          templateId
          creatorId
          updaterId
          createdAt
          updatedAt
          virtualRoot {
            ...DocumentEditorCmp_VirtualRoot_Section
          }
        }
      }
    }
  }
`);

export type DocumentEditorCmp_TemplateDependency = ResultOf<
  typeof DocumentEditorCmp_OneTemplateDependency_QueryDocument
>['findOneTemplate'];
